import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.domains',
    'resource:data.dimensions.domains.entities.domain',
    'resource:data.dimensions.proposals',
    'resource:data.dimensions.proposals.entities.proposal',
    'resource:data.dimensions.proposals.entities.proposal.attributes.documents',
    'resource:data.dimensions.proposals.entities.proposal.attributes.pastPerformance',
    'resource:data.dimensions.proposals.entities.proposal.attributes.proposalFile',
    'resource:data.dimensions.proposals.entities.proposal.attributes.status',
    'resource:data.dimensions.proposals.entities.proposal.attributes.organizationOffering',
    'resource:data.dimensions.proposals.entities.proposal.attributes.salesforceId',
    'resource:data.dimensions.proposals.entities.proposal.attributes.dueDate',
    'resource:data.dimensions.proposals.entities.proposal.attributes.expectedCloseDate',
    'resource:data.dimensions.proposals.entities.proposal.attributes.amount',
    'resource:data.dimensions.proposals.entities.proposal.attributes.client',
    'resource:data.dimensions.proposals.entities.proposal.attributes.organization',
    'resource:data.dimensions.proposals.entities.proposal.attributes.winThemes',
    'resource:data.dimensions.proposals.entities.proposal.attributes.valuePropositions',
    'resource:data.dimensions.proposalDomain',
    'resource:data.dimensions.proposalDomain.entities.entry',
    'resource:data.dimensions.proposalDomain.entities.entry.attributes.domain',
    'resource:data.dimensions.proposalDomain.entities.entry.attributes.proposal',
    'resource:data.dimensions.innovationIdeas',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea.attributes.jiraIssueKey',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea.attributes.organizationOffering',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea.attributes.status',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea.attributes.laneOfSupport',
    'resource:data.dimensions.innovationIdeas.entities.innovationIdea.attributes.executiveCommitteeApproval',
    'resource:data.dimensions.innovationAssets',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.aiEnabled',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.notes',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.swagImpact',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.pilotProject',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.laneOfSupport',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.aiPlatform',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.assetLink',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.documentationLink',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.owner',
    'resource:data.dimensions.innovationAssets.entities.innovationAsset.attributes.approvalStatus',
    'resource:data.dimensions.innovationAssetsProject',
    'resource:data.dimensions.innovationAssetsProject.entities.entry',
    'resource:data.dimensions.innovationAssetsProject.entities.entry.attributes.innovationAsset',
    'resource:data.dimensions.innovationAssetsProject.entities.entry.attributes.project',
    'resource:data.dimensions.offerings',
    'resource:data.dimensions.offerings.entities.offering',
    'resource:data.dimensions.offerings.entities.offering.attributes.documents',
    'resource:data.dimensions.offerings.entities.task',
    'resource:data.dimensions.offerings.entities.phase',
    'resource:data.dimensions.orgOfferingDomain',
    'resource:data.dimensions.orgOfferingDomain.entities.entry',
    'resource:data.dimensions.orgOfferingDomain.entities.entry.attributes.organizationOffering',
    'resource:data.dimensions.orgOfferingDomain.entities.entry.attributes.domain',
    'resource:data.dimensions.innovationAssetsOffering',
    'resource:data.dimensions.innovationAssetsOffering.entities.entry',
    'resource:data.dimensions.innovationAssetsOffering.entities.entry.attributes.innovationAsset',
    'resource:data.dimensions.innovationAssetsOffering.entities.entry.attributes.offering',
    'resource:data.dimensions.organizationOfferings',
    'resource:data.dimensions.organizationOfferings.entities.entry',
    'resource:data.dimensions.organizationOfferings.entities.entry.attributes.documents',
    'resource:data.dimensions.organizationOfferings.entities.entry.attributes.organization',
    'resource:data.dimensions.organizationOfferings.entities.entry.attributes.offering',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.affiliate',
    'resource:data.dimensions.organization.entities.affiliate.attributes.documents',
    'resource:data.dimensions.organization.entities.division',
    'resource:data.dimensions.organization.entities.division.attributes.documents',
    'resource:data.dimensions.organization.entities.department',
    'resource:data.dimensions.organization.entities.department.attributes.documents',
    'resource:data.dimensions.organization.entities.subdepartment',
    'resource:data.dimensions.organization.entities.subdepartment.attributes.documents',
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.jobTitle',
    'resource:data.dimensions.personnel.entities.employee.attributes.resumeFile',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.enums.leaderType',
    'resource:data.enums.leaderType.entries.manager',
    'resource:data.enums.leaderType.entries.indirectManager',
    'resource:data.enums.leaderType.entries.other',
    'resource:data.enums.proposalStatus',
    'resource:data.enums.proposalStatus.entries.assessing',
    'resource:data.enums.proposalStatus.entries.assigned',
    'resource:data.enums.proposalStatus.entries.capabilityLeadReview',
    'resource:data.enums.proposalStatus.entries.closedLost',
    'resource:data.enums.proposalStatus.entries.closedWon',
    'resource:data.enums.proposalStatus.entries.inProgress',
    'resource:data.enums.proposalStatus.entries.noBid',
    'resource:data.enums.proposalStatus.entries.submitted',
    'resource:data.dimensions.personnelLeaders',
    'resource:data.dimensions.personnelLeaders.entities.relationship',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leader',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leaderType',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.personnel',
    'resource:data.dimensions.employeeSkills',
    'resource:data.dimensions.employeeSkills.entities.entry',
    'resource:data.dimensions.employeeSkills.entities.entry.attributes.employee',
    'resource:data.dimensions.employeeSkills.entities.entry.attributes.skill',
    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',
    'resource:data.dimensions.projects.entities.project.attributes.status',
    'resource:data.dimensions.projects.entities.project.attributes.organization',
    'resource:data.dimensions.projects.entities.project.attributes.organizationOffering',
    'resource:data.dimensions.projects.entities.project.attributes.client',
    'resource:data.dimensions.projects.entities.projectArea',
    'resource:data.dimensions.projectDomain',
    'resource:data.dimensions.projectDomain.entities.entry',
    'resource:data.dimensions.projectDomain.entities.entry.attributes.project',
    'resource:data.dimensions.projectDomain.entities.entry.attributes.domain',
    'resource:data.dimensions.skills',
    'resource:data.dimensions.skills.entities.skill',
    'resource:data.dimensions.skills.entities.skill.attributes.isCertificate',
    'resource:data.dimensions.engagements',
    'resource:data.dimensions.engagements.entities.engagement',
    'resource:data.dimensions.engagements.entities.engagement.attributes.employee',
    'resource:data.dimensions.engagements.entities.engagement.attributes.project',
    'resource:data.dimensions.engagements.entities.engagement.attributes.role',
    'resource:data.dimensions.engagements.entities.engagement.attributes.isCurrent',
    'resource:data.dimensions.engagements.entities.engagement.attributes.similarEmployee',
    'resource:data.dimensions.engagements.entities.engagement.attributes.proposedEmployee',
    'resource:data.dimensions.allocations',
    'resource:data.dimensions.allocations.entities.allocation',
    'resource:data.dimensions.allocations.entities.allocation.attributes.engagement',
    'resource:data.dimensions.allocations.entities.allocation.attributes.plannedWeeklyHours',
    'resource:data.dimensions.allocations.entities.allocation.attributes.actualWeeklyHours',
    'resource:data.dimensions.allocations.entities.allocation.attributes.isCurrent',
    'resource:data.dimensions.jobTitles',
    'resource:data.dimensions.jobTitles.entities.jobTitle',
    'resource:data.dimensions.clients',
    'resource:data.dimensions.clients.entities.client',
    'resource:data.dimensions.proposalPersonnel',
    'resource:data.dimensions.proposalPersonnel.entities.entry',
    'resource:data.dimensions.proposalPersonnel.entities.entry.attributes.personnel',
    'resource:data.dimensions.proposalPersonnel.entities.entry.attributes.proposal',
    'resource:data.dimensions.proposalPersonnel.entities.entry.attributes.type',
    'resource:data.dimensions.glAccounts',
    'resource:data.dimensions.glAccounts.entities.account',
    'resource:data.dimensions.glExpenses',
    'resource:data.dimensions.glExpenses.entities.entry',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.account',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.amount',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.organization',
    'resource:data.dimensions.glExpenses.entities.entry.attributes.project',
    'resource:data.dimensions.cursorUsageEvents',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.externalEventId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.occurredAt',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.userEmail',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.client',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.repoUrl',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.conversationId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.jiraKey',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.requestSummary',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.requestType',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.artifacts',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.linesAdded',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.estimatedHoursSaved',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.confidence',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.model',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.generationId',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.inputTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.outputTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.cacheReadTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.cacheWriteTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.totalTokens',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.tokenSource',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.estimatedCostUsd',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.costSource',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.netRoiUsd',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.actualCursorMinutes',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.commitSha',
    'resource:data.dimensions.cursorUsageEvents.entities.cursorUsageEvent.attributes.project',
    'resource:solutions.apps.employeePlanningAttainDigital',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.employeeOrg',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.engagements',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.projects',
    'resource:solutions.apps.innovationTracker.innovationTracker',
    'resource:solutions.apps.innovationTracker.pages.assetTracker',
    'resource:solutions.apps.innovationTracker.pages.ideasDashboard',
    'resource:solutions.apps.innovationTracker.pages.ideasList',
    'resource:solutions.apps.proposals.proposals',
    'resource:solutions.apps.proposals.pages.proposalList',
    'resource:solutions.apps.proposals.pages.proposalDetails',
    'resource:solutions.apps.financialPerformance.financialPerformance',
    'resource:solutions.apps.financialPerformance.pages.financialPerformanceOverview',
    'resource:solutions.mosaic.pages.proposals.proposalList',
    'resource:solutions.mosaic.pages.proposals.proposalDetails',
    'resource:solutions.mosaic.widgets.proposals.proposalsTable',
    'resource:solutions.mosaic.widgets.proposals.editProposalModal',
    'resource:solutions.mosaic.widgets.proposals.editProposalPersonnelRow',
    'resource:solutions.mosaic.widgets.proposals.proposalPersonnelTable',
    'resource:solutions.mosaic.widgets.proposals.proposalDomainTable',
    'resource:solutions.mosaic.widgets.proposals.proposalAttributes',
    'resource:solutions.mosaic.widgets.proposals.createProposalModal',
    'resource:solutions.mosaic.widgets.proposals.editProposalDomainRow',
    'resource:solutions.mosaic.actions.proposals.saveProposal',
    'resource:solutions.mosaic.actions.proposals.deleteProposalPersonnelRow',
    'resource:solutions.mosaic.actions.proposals.saveProposalPersonnelRow',
    'resource:solutions.mosaic.actions.proposals.saveProposalDomainRow',
    'resource:solutions.mosaic.actions.proposals.deleteProposalDomainRow',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.employeeOrg',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.engagements',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.projects',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.engagementsTable',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.projectsTable',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.orgEmployeeTree',
    'resource:solutions.mosaic.pages.innovationTracker.ideasList',
    'resource:solutions.mosaic.pages.innovationTracker.innovationDashboard',
    'resource:solutions.mosaic.pages.innovationTracker.assetTracker',
    'resource:solutions.mosaic.widgets.innovationTracker.ideasByLos',
    'resource:solutions.mosaic.widgets.innovationTracker.assetsByLos',
    'resource:solutions.mosaic.widgets.innovationTracker.ideasByStatus',
    'resource:solutions.mosaic.widgets.innovationTracker.ideasReportCard',
    'resource:solutions.mosaic.widgets.innovationTracker.ideasTable',
    'resource:solutions.mosaic.widgets.innovationTracker.ideasTablePage',
    'resource:solutions.mosaic.widgets.innovationTracker.assetTracker',
    'resource:solutions.mosaic.widgets.innovationTracker.assetOrganizationTable',
    'resource:solutions.mosaic.widgets.innovationTracker.assetOrganizationTableDetails',
    'resource:solutions.mosaic.widgets.innovationTracker.employeeAssetLeaderboard',
    'resource:solutions.mosaic.widgets.innovationTracker.assetsByPlatform',
    'resource:solutions.mosaic.pages.financialPerformance.financialPerformanceOverview',
    'resource:solutions.mosaic.widgets.financialPerformance.revenueMetricsReportCard',
    'resource:solutions.mosaic.widgets.financialPerformance.yearlyRevenueTable',
    'resource:solutions.mosaic.widgets.financialPerformance.ytdRevenueByOrg',
    'package:data.universal.assistantChat',
  ],
  description:
    'A package containing entities and resources specific to internal Attain use',
  name: 'Attain Internal',
} as const satisfies core.quiver.Package
